import {
  ACCOUNT_REPRESENTATIVES_LOADED,
  LOAD_ACCOUNT_REPRESENTATIVES,
  RESET_ACCOUNT_REPRESENTATIVES,
  SYNC_FAILED,
} from './actionTypes';
import type { IAccountRepresentativesState } from './types';

export const initialState = {
  error: null,
  loaded: false,
  loading: false,
  accountRepresentatives: [],
  loadedProductType: '',
};

export const reducer = (
  state: IAccountRepresentativesState,
  action: { type: any; payload?: any },
) => {
  switch (action.type) {
    case LOAD_ACCOUNT_REPRESENTATIVES:
      return { ...state, error: null, loading: true, accountRepresentatives: [] };
    case ACCOUNT_REPRESENTATIVES_LOADED:
      return {
        ...state,
        error: null,
        accountRepresentatives: action.payload.data,
        loadedProductType: action.payload.productType,
        loading: false,
        loaded: true,
      };

    case RESET_ACCOUNT_REPRESENTATIVES:
      return initialState;
    case SYNC_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        loadedProductType: action.payload.productType,
      };
    default:
      return state;
  }
};
